import { Controller } from "@hotwired/stimulus"

/**
 * Selects the tab whose panel arrived, on `turbo:frame-load` rather than on
 * click, so a failed or superseded request never leaves the strip pointing at
 * a panel the listener is not looking at (#1913). The panel names its own tab;
 * matching the frame's `src` would tie the strip to URL spelling.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["tab"]
  static values = { frame: String }

  declare readonly tabTargets: HTMLElement[]
  declare readonly frameValue: string

  panelLoaded(event: Event) {
    const frame = event.target as HTMLElement | null
    if (frame?.id !== this.frameValue) return

    const loadedKey =
      frame.querySelector<HTMLElement>("[data-tab-key]")?.dataset.tabKey
    if (!loadedKey) return

    let url: string | undefined

    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.tabKey === loadedKey
      tab.setAttribute("aria-selected", String(selected))
      if (selected) url = tab.getAttribute("href") ?? undefined
    })

    // For chrome outside the frame. The address comes off the link because
    // `window.location` still holds the previous tab at this point.
    this.dispatch("selected", { detail: { key: loadedKey, url } })
  }
}
